var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "mds-label",
    {
      attrs: {
        "on-dark": _vm.onDark,
        size: _vm.size,
        optional: _vm.optional,
        "optional-text": _vm.optionalText,
        required: _vm.required,
        "required-text": _vm.requiredText,
        text: _vm.label,
        for: _vm.ariaInputId,
        id: _vm.ariaLabelId,
        "hidden-label": _vm.hiddenLabel,
      },
    },
    [
      _vm._t("mds-microcopy-above", function () {
        return [
          _vm.microcopyAbove
            ? _c("mds-microcopy", {
                attrs: { size: _vm.size, "on-dark": _vm.onDark },
                domProps: { innerHTML: _vm._s(_vm.microcopyAbove) },
              })
            : _vm._e(),
        ]
      }),
      _vm._v(" "),
      _c(
        _vm.selectType,
        _vm._g(
          _vm._b(
            {
              ref: "childComponent",
              tag: "component",
              attrs: {
                "data-mds-version": _vm.version,
                "data-set": _vm.data,
                error: _vm.error,
                "display-top": _vm.displayTop,
                "on-dark": _vm.onDark,
                size: _vm.size,
                disabled: _vm.disabled,
                "initial-selection": _vm.selectedItems,
                placeholder: _vm.placeholder,
                "results-id": _vm.comboboxId(),
                "aria-label": _vm.ariaLabelId,
                "aria-input-id": _vm.ariaInputId,
                "multiple-item-limit": _vm.itemLimit,
                required: _vm.required,
                "no-results-label": _vm.noResultsLabel,
              },
              on: { input: _vm.handleInputEvent },
              scopedSlots: _vm._u(
                [
                  {
                    key: "mds-combo-box-result-description",
                    fn: function (slotProps) {
                      return [
                        _vm._t(
                          "mds-combo-box-result-description",
                          null,
                          null,
                          slotProps
                        ),
                      ]
                    },
                  },
                  {
                    key: "mds-combo-box-selection-description",
                    fn: function (slotProps) {
                      return [
                        _vm._t(
                          "mds-combo-box-selection-description",
                          null,
                          null,
                          slotProps
                        ),
                      ]
                    },
                  },
                ],
                null,
                true
              ),
            },
            "component",
            _vm.$attrs,
            false
          ),
          _vm.userListeners
        )
      ),
      _vm._v(" "),
      _vm.error
        ? _c(
            "div",
            {
              class: _vm.$style["mds-combo-box__field-error-wrapper"],
              attrs: { role: "alert", "aria-live": "assertive" },
            },
            _vm._l(_vm.errorText, function (text, index) {
              return _c("mds-field-error", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.error,
                    expression: "error",
                  },
                ],
                key: index,
                attrs: { size: _vm.size, text: text, "on-dark": _vm.onDark },
              })
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._t("mds-microcopy-below", function () {
        return [
          _vm.microcopyBelow
            ? _c("mds-microcopy", {
                attrs: { size: _vm.size, "on-dark": _vm.onDark },
                domProps: { innerHTML: _vm._s(_vm.microcopyBelow) },
              })
            : _vm._e(),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }